import { useContext, useEffect } from 'react'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'

// 브라우저 새로고침, 탭 닫기 등 강제 이탈 방지
const useBeforeUnload = (enabled: boolean) => {
    useEffect(() => {
        if (!enabled) return

        const handler = (e: BeforeUnloadEvent) => {
            e.preventDefault()
            e.returnValue = '' // 표준 메시지는 표시되지 않음
        }

        window.addEventListener('beforeunload', handler)
        return () => window.removeEventListener('beforeunload', handler)
    }, [enabled])
}

// SPA 내 라우팅 차단
const useBlocker = (blocker: (tx: any) => void, when: boolean) => {
    const { navigator } = useContext(NavigationContext) as any

    useEffect(() => {
        if (!when) return
        if (!navigator?.block) return

        const unblock = navigator.block((tx: any) => {
            const autoUnblockTx = {
                ...tx,
                retry() {
                    unblock()
                    tx.retry()
                },
            }
            blocker(autoUnblockTx)
        })

        return unblock
    }, [navigator, blocker, when])
}

const usePrompt = (message: string, when: boolean) => {
    useBeforeUnload(when)

    useBlocker((tx) => {
        const confirmed = window.confirm(message)
        if (confirmed) {
            tx.retry()
        }
    }, when)
}

export default usePrompt
